import React from 'react';
import Geosuggest from 'react-geosuggest';
import './styles.css';

const AddressStep = ({ fields, assignRef, onSuggestSelect, onInputKeyDown }) => (
  <div className="step-content first-step-content location-step">
    <h2>Hvar er eignin staðsett?</h2>
    <p>
      Sláðu inn heimilisfangið á eigninni hér fyrir neðan.<br />
      Ef pinninn er ekki á réttum stað, endilega færðu hann til.
    </p>
    <div className="input-wrapper">
      <Geosuggest
        initialValue={fields.address.value}
        ref={assignRef ? c => assignRef('address', c) : null}
        placeholder="Sláðu inn heimilsfang"
        country="is"
        onSuggestSelect={e => onSuggestSelect(e)}
        types={['geocode']}
        onKeyPress={onInputKeyDown}
      />
    </div>
  </div>
);

AddressStep.propTypes = {
  fields: React.PropTypes.object.isRequired,
  assignRef: React.PropTypes.func,
  onSuggestSelect: React.PropTypes.func.isRequired,
  onInputKeyDown: React.PropTypes.func.isRequired,
};

export default AddressStep;



// WEBPACK FOOTER //
// ./src/browser/steps/AddressStep/AddressStep.js